export const componentName = 'B2bProgress';
